<template>
  <v-row v-if="selectedAccount" align="start" justify="center">
    <v-col>
      <Account :account="selectedAccount" @onClose="onCloseAccount"></Account>
    </v-col>
  </v-row>
  <v-row v-else align="start" justify="center">
    <v-col cols="12">
      <v-toolbar flat>
        <v-icon large class="mr-3">attach_money</v-icon>
        <v-toolbar-title>Account</v-toolbar-title>
        <v-tooltip right color="transparent">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon color="primary">mdi-information</v-icon>
            </v-btn>
          </template>
          <v-card width="300">
            <v-card-title>Account</v-card-title>
            <v-card-text>Support brokers: OANDA, FXCM</v-card-text>
          </v-card>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="onNewInSteps">Create New Account</v-btn>
      </v-toolbar>
    </v-col>
    <v-col v-if="newItem" cols="6">
      <CRUD :new-item="newItem" @closed="onClosed"></CRUD>
    </v-col>
    <v-col v-if="NewInSteps">
      <NewInSteps></NewInSteps>
    </v-col>

    <v-col v-else-if="accounts" cols="12">
      <v-data-iterator
        :items="accounts"
        :items-per-page.sync="itemsPerPage"
        :footer-props="{ itemsPerPageOptions }"
      >
        <template v-slot:default="props">
          <v-row align="start" justify="center">
            <v-col v-for="item in props.items" :key="item.id" cols="12" sm="6" md="4" lg="4">
              <Card :item="item" @onSelect="onSelectedAccount"></Card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
    <v-col v-else cols="4" align-self="center">
      <v-card flat class="justify-center">
        <v-img src="@/assets/bluetheme/init.png"></v-img>
        <v-card-text>You has no trading account. Please take a tour and step by step initiate your account.</v-card-text>
        <v-card-actions>
          <v-btn outlined color="primary" block to="/init">Initiate Step by Step Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { ACCOUNT, SCHEMA } from "@/store/actions.type";
import Card from "@/components/accounts/Card.vue";
import CRUD from "@/components/accounts/CRUD.vue";
import NewInSteps from "@/components/accounts/NewInSteps.vue";
import Account from "@/views/Account.vue";

export default {
  name: "Accounts",
  components: {
    Card,
    NewInSteps,
    CRUD,
    Account
  },
  data() {
    return {
      itemsPerPageOptions: [6, 12, 18],
      itemsPerPage: 6,
      newItem: null,
      NewInSteps: false,
      selectedAccount: null
    };
  },
  computed: {
    ...mapGetters(["accounts", "isAuthenticated", "currentUser"])
  },
  watch: {
    currentUser(v) {
      this.$store.dispatch(ACCOUNT.FETCH, v.id);
    }
  },
  mounted() {
    if (this.currentUser) {
      this.$store.dispatch(ACCOUNT.FETCH, this.currentUser.id);
    }
  },
  methods: {
    onSelectedAccount(v) {
      this.selectedAccount = v;
    },
    onCreate() {
      this.$store.dispatch(SCHEMA.GET, "account").then(result => {
        this.newItem = result.data;
      });
    },
    onClosed() {
      this.newItem = null;
    },
    onNewInSteps() {
      this.NewInSteps = true;
    },
    onCloseAccount(v) {
      if (v.id == this.selectedAccount.id) {
        this.selectedAccount = null;
      }
    }
  }
};
</script>
<style></style>
